<template>
  <div>
    <el-row>
      <el-col :span="16" class="cs-studyAbroad-step2-left">
        <serviceInfoList :dataIn="serviceInfoListData" />
        <div class="cs-studyAbroad-step2-priceInfo">
          <el-row
            v-if="!isChannelPayeeType"
            ><el-col :span="6">手续费</el-col
            ><el-col :span="12">{{
              totalServiceCharge | toCurrency(dataIn.currency)
            }}</el-col></el-row
          >
          <el-row
            ><el-col :span="6">总计</el-col
            ><el-col :span="12">{{
              accountAmount | toCurrency(dataIn.currency)
            }}</el-col></el-row
          >
          <el-row
            v-if="!isChannelPayeeType"
            ><el-col :span="6">已支付</el-col
            ><el-col :span="12">{{
              totalPayment | toCurrency(dataIn.currency)
            }}</el-col></el-row
          >
          <el-row
            v-if="!isChannelPayeeType"
            ><el-col :span="6">需支付</el-col
            ><el-col :span="12">{{
              accountAmountLeft | toCurrency(dataIn.currency)
            }}</el-col></el-row
          >
        </div>
      </el-col>
      <el-col :span="8" class="cs-studyAbroad-step2-payment">
       <accountInfo :isReadonly="isReadonly" :payeeTypeEditable="true" :paymentEditable="true" :disabledSave="true" :dataIn="accountInfoData" @loadAccount="onLoadAccount" @savePaymentStart="onSavePaymentStart" @savePaymentEnd="onSavePaymentEnd"/>
      </el-col>
    </el-row>

  </div>
</template>

<style lang="scss" scoped>
.cs-studyAbroad-step2-payment {
  padding: 20px;
}
.cs-studyAbroad-step2-left {
  border-right: 1px solid #ced3d9;
}
.cs-studyAbroad-step2-priceInfo {
  padding-top: 20px;
  padding-bottom: 20px;

  line-height: 25px;
}
</style>

<script>
import serviceInfoList from "./serviceInfoList";
import accountInfo from "../accountInfo";

export default {
  props: {
    isReadonly: Boolean,
    dataIn: {
      studentId: Number,
      workflowId: Number,
      currency: Number,
      serviceList: Array,
      model: Object,
    },
  },
  data() {
    return {
      serviceInfoListData: {
        currency: 0,
        serviceList: [],
      },
      accountAmount:0,
      totalServiceCharge: 0,
      totalPayment: 0,
      accountAmountLeft: 0,
      accountInfoData:{}
    };
  },
  components: {
    serviceInfoList,
    accountInfo
  },
  computed: {
    isChannelPayeeType() {
      if (!this.dataIn || !this.dataIn.model)
        return false;

      return this.dataIn.model.payeeType == this.GLOBAL.enumPayeeType.Channel;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.dataIn) {
        this.serviceInfoListData = {
          currency: this.dataIn.currency,
          serviceList: this.dataIn.serviceList,
        };
        this.accountAmount = this.dataIn.serviceList.reduce(
          (sum, x) => sum + x.totalPrice - x.discountAmount - x.cashDecreasedAmount,
          0
        );

        this.accountInfoData = {
          studentId: this.dataIn.studentId,
          workflowId: this.dataIn.workflowId,
          currency: this.dataIn.currency,
          accountAmount: this.accountAmount,
          model: this.dataIn.model
        }
      }
    },
    onLoadAccount(data){
      this.totalServiceCharge = data.totalServiceCharge;
      this.totalPayment = data.totalPayment;
      this.accountAmountLeft = data.accountAmountLeft;
    },
    onSavePaymentStart(){
      this.$emit("savePaymentStart");
    },
    onSavePaymentEnd(){
      this.$emit("savePaymentEnd");
    }
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflow/step2.vue